import request from '@/utils/request'


// 查询任务主信息列表
export function listTaskMain(query) {
  return request({
    url: '/task/task/main/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询任务主信息分页
export function pageTaskMain(query) {
  return request({
    url: '/task/task/main/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询任务主信息详细
export function getTaskMain(data) {
  return request({
    url: '/task/task/main/detail',
    method: 'get',
    params: data
  })
}

// 新增任务主信息
export function addTaskMain(data) {
  return request({
    url: '/task/task/main/add',
    method: 'post',
    data: data
  })
}

// 修改任务主信息
export function updateTaskMain(data) {
  return request({
    url: '/task/task/main/edit',
    method: 'post',
    data: data
  })
}

// 删除任务主信息
export function delTaskMain(data) {
  return request({
    url: '/task/task/main/delete',
    method: 'post',
    data: data
  })
}

// 获取筛选项枚举数据
export function getEnumOptions() {
  return request({
    url: '/task/task/main/enum/options',
    method: 'get'
  })
}

// 更新任务状态
export function updateTaskStatus(data) {
  return request({
    url: '/task/task/main/updateStatus',
    method: 'post',
    data: data
  })
}

// 审核任务
export function auditTaskMain(data) {
  return request({
    url: '/task/task/main/audit',
    method: 'post',
    data: data
  })
}

// 获取分成比例设置
export function getShareRatioSetting() {
  return request({
    url: '/task/task/main/share-ratio/get',
    method: 'get'
  })
}

// 设置分成比例
export function setShareRatioSetting(data) {
  return request({
    url: '/task/task/main/share-ratio/set',
    method: 'post',
    data: data
  })
}
